import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import './index.scss'

const DestructiveConfirmationOverlay = ({
  message,
  subMessage,
  onConfirm,
  onCancel,
  onConfirmActionTitle,
  confirmIsPrimary
}: any) => {
  const buttonSettings = confirmIsPrimary
    ? {
        primaryOnClick: onConfirm,
        secondaryOnClick: onCancel,
        primaryMessage: onConfirmActionTitle,
        secondaryMessage: <FormattedMessage id="Cancel" defaultMessage="Cancel" />
      }
    : {
        primaryOnClick: onCancel,
        secondaryOnClick: onConfirm,
        primaryMessage: <FormattedMessage id="Cancel" defaultMessage="Cancel" />,
        secondaryMessage: onConfirmActionTitle
      }

  return (
    <div className="confirmation__overlay">
      <div className="confirmation__box">
        <p className="confirmation__message">{message}</p>
        {!!subMessage && <p className="confirmation__sub_message">{subMessage}</p>}
        <div className="confirmation__actionblock">
          <button type="button" className="button button--secondary" onClick={buttonSettings.secondaryOnClick}>
            {buttonSettings.secondaryMessage}
          </button>
          <button type="button" className="button button--primary" onClick={buttonSettings.primaryOnClick}>
            {buttonSettings.primaryMessage}
          </button>
        </div>
      </div>
    </div>
  )
}

DestructiveConfirmationOverlay.displayName = 'DestructiveConfirmationOverlay'

DestructiveConfirmationOverlay.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirmActionTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  confirmIsPrimary: PropTypes.bool
}

DestructiveConfirmationOverlay.defaultProps = {
  message: 'Are you sure?',
  subMessage: '',
  onConfirmActionTitle: <FormattedMessage id="Add" defaultMessage="Add" />,
  confirmIsPrimary: false
}

export default DestructiveConfirmationOverlay
